export const RAISE_CHAT_NOTIFICATIONS = 'RAISE_CHAT_NOTIFICATIONS';
export const CLEAR__CHAT_NOTIFICATIONS = 'CLEAR__CHAT_NOTIFICATIONS';
export const SET_CHANNEL_NOTIFICATIONS = 'SET_CHANNEL_NOTIFICATIONS';
export const INCREASE_CHANNEL_NOTIFICATIONS = 'INCREASE_CHANNEL_NOTIFICATIONS';
export const DECREASE_CHANNEL_NOTIFICATIONS = 'DECREASE_CHANNEL_NOTIFICATIONS';
export const CLEAR_CHANNEL_NOTIFICATIONS = 'CLEAR_CHANNEL_NOTIFICATIONS';
export const IS_SOCKET_OPEN = 'IS_SOCKET_OPEN';
export const IS_SUBSCRIBED = 'IS_SUBSCRIBED';
